// NPM
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// ANT COMPONENTS
import { CheckCircleFilled } from '@ant-design/icons';

// TYPES
import { CustomerCompanyFormInputType } from 'Types/customer-form.types';

// STYLE
import "./customer-create-success.scss";

interface CustomerCreateSuccessComponentProps {
    data: Partial<CustomerCompanyFormInputType>
}

const CustomerCreateSuccessComponent: React.FC<CustomerCreateSuccessComponentProps> = ({
    data
}) => {
    
    const { t } = useTranslation();

    return (
        <div className="customer-create-success-container">
            <div>
                <CheckCircleFilled
                    style={{fontSize: 100, color: "#29A7D3"}}
                />
            </div>
            <div className="mt-25">
                {t("txt.customerRegistrationSuccess", 
                    { customerAccountName: data?.customerName || "" }
                )}
            </div>
            <div className="mt-25">
                {t("txt.customerRegistrationEmailNotification", 
                    { customerEmail: data?.adminEmailAddress || data?.emailAddress }
                )}
            </div>
            {
                data?.businessRegistrationNumber ?
                    <div className="mt-25">
                        {t("txt.registrationID")}<br /> {data?.businessRegistrationNumber}
                    </div> : null
            }
        </div>
    );
}

export default CustomerCreateSuccessComponent;